import React from "react";

import {mt, p, pl} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";

import {ILocationGenericParagraphList} from "../../../helpers/location_generic_description/constants";

interface IProps {
    texts: ILocationGenericParagraphList["text"];
}

export const ParagraphListType = ({texts}: IProps) => {
    return (
        <ul css={[pl(2), mt(1)]}>
            {texts.map((singleText, index) => (
                <Text as="li" key={index} variant="body_copy_2" css={[p(0, 0, 0.5, 0)]}>
                    {singleText}
                </Text>
            ))}
        </ul>
    );
};
